module.exports = __webpack_public_path__ + "img/logo.01df0cef.png";